<template>
  <Frame
    class="page-frame"
    :loading="loading"
    :finished="finished"
    @onLoad="onLoadFrame"
    @onRefresh="onRefreshFrame"
  >
    <template v-slot:header>
      <TabToggle :default-id="tabIndex" @onChange="onChangeTab" />
    </template>
    <template v-slot:body>
      <div class="body-wrapper">
        <Apply v-if="tabIndex == 1" @history="onChangeTab({ id: 2 })" />
        <RecordListParent v-if="tabIndex == 2" />
      </div>
    </template>
  </Frame>
</template>

<script>
import Frame from "@/components/frame.vue";
import TabToggle from "./components/tabToggle.vue";
import Apply from "./components/apply.vue";
import RecordListParent from "./components/recordListParent.vue";
import { ref } from "vue";
export default {
  name: "parentIndex",
  components: {
    Frame,
    TabToggle,
    Apply,
    RecordListParent,
  },
  setup() {
    const tabIndex = ref(localStorage.getItem("tabIndex") || 1);
    const onChangeTab = (data) => {
      let { id } = data;
      tabIndex.value = id;
      localStorage.setItem("tabIndex", id);
    };
    return {
      tabIndex,
      onChangeTab,
      list: ref([]),
    };
  },
};
</script>

<style lang="less" scoped>
.body-wrapper {
  height: calc(100vh - 44px);
}
/deep/ .van-config-provider {
  height: 100%;
}
</style>
